// extracted by mini-css-extract-plugin
export default {"select":"AdminMobileSelect_select__4AXE6"};